import { FC, useState } from "react";

import { Button, Button as MuiButton, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import styled from "styled-components";
import useForm from "../../hooks/useForm";
import { USER_EMAIL } from "../../utils/constants";

import Checkbox from "../UI/Checkbox";
import Input from "../UI/Input";
import { Website } from "../../pages/CreatePage";
import { request } from "../../utils/axios-utils";
import { useCopyToClipboard } from "usehooks-ts";
import { useTranslation } from "react-i18next";

const DownArrow = require("../../assets/down.png");

interface IFormProps {
  value: any;
  id: number;
}

const Form: FC<IFormProps> = ({ value, id }) => {
  const [domainError, setDomainError] = useState(false);
  const [showKey, setShowKey] = useState(false);

  const { t } = useTranslation();

  const titlePlaceholder = t("controlPanelCreatePageInputTitlePlaceholder");
  const agreeValidation = t("controlPanelCreatePageInputAgreeValidation");
  const titleValidation = t("controlPanelCreatePageInputTitleValidation");
  const domainValidation = t("controlPanelCreatePageInputDomenValidation");

  const initialValue = {
    name: value?.name,
    domain: value?.domain,
    // email: value?.email,
    flag_alerts: value?.flag_alerts,
  };

  const navigate = useNavigate();

  const email = Cookies.get(USER_EMAIL);

  const { values, handleInputChange, errors, setErrors } =
    useForm(initialValue);

  const validate = () => {
    let temp: Website = {};
    temp.name = values.name ? "" : titleValidation;
    // temp.email = values.email ? "" : titleValidation;
    temp.domain =
      /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/.test(
        values.domain
      )
        ? ""
        : domainValidation;
    temp.flag_alerts = values.flag_alerts
      ? ""
      : "Примите условия чтобы продолжить";

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();

    const data = {
      ...values,
      project_id: id,
    };

    if (validate()) {
      request({ url: "api/v2/project/update", method: "put", data: data })
        .then((res): any => {
          if (res.data) {
            navigate("/panel");
          }
        })
        .catch((err) => {
          setDomainError(true);
          console.error(err.message);
        });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, copy] = useCopyToClipboard();

  return (
    <>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <FormContainer>
          <Input
            id="component-name"
            defaultValue={value.name}
            name="name"
            label={t("controlPanelCreatePageInputTitle")}
            placeholder={titlePlaceholder}
            multiline={true}
            variant="standard"
            error={errors.name}
            onChange={handleInputChange}
          />
          <Input
            id="component-domain-change"
            defaultValue={value.domain}
            name="domain"
            label={t("controlPanelCreatePageInputDomen")}
            placeholder="example.com"
            multiline={true}
            variant="standard"
            error={errors.domain || domainError}
            onChange={handleInputChange}
          />
          <ShowKey>
            <div className="top" onClick={() => setShowKey(!showKey)}>
              <h1>{t("controlPanelUpdatePageKeys")}</h1>
              <img
                src={DownArrow}
                className={showKey ? "arrow-down open" : "arrow-down"}
                alt="down"
              />
            </div>
            {showKey && (
              <>
                <KeyBlock>
                  <KeyTitle>{t("controlPanelKeysPagePublicKeyInfo")}</KeyTitle>
                  <div className="key_copy">
                    <Button
                      variant="text"
                      onClick={() => copy(value.tokens.domain_open_key)}
                    >
                      {t("controlPanelKeysPagePublicKeyInfoButton")}
                    </Button>
                    <TextField
                      aria-readonly
                      value={value.tokens.domain_open_key}
                      fullWidth
                    />
                  </div>
                </KeyBlock>
                <KeyBlock>
                  <KeyTitle>{t("controlPanelKeysPageSecretKeyInfo")}</KeyTitle>
                  <div className="key_copy">
                    <Button
                      variant="text"
                      onClick={() => copy(value.tokens.domain_key)}
                    >
                      {t("controlPanelKeysPageSecretKeyInfoButton")}
                    </Button>
                    <TextField
                      aria-readonly
                      value={value.tokens.domain_key}
                      fullWidth
                    />
                  </div>
                </KeyBlock>
              </>
            )}
          </ShowKey>

          <Input
            id="component-email"
            value={email}
            name="email"
            type="email"
            required={true}
            label={t("controlPanelCreatePageInputEmail")}
            variant="standard"
            multiline={true}
            disabled={true}
            onChange={handleInputChange}
          />
          <Checkbox
            onChange={handleInputChange}
            name="flag_alerts"
            required={true}
            type="checkbox"
            errors={errors.flag_alerts}
            errorMessage={agreeValidation}
            label={t("controlPanelCreatePageInputAgree")}
            value={values.flag_alerts}
          />
        </FormContainer>
        <ButtonContainer>
          <MuiButton onClick={() => navigate(-1)} variant="outlined">
            {t("controlPanelUpdateFormButtonFirst")}
          </MuiButton>
          <MuiButton type="submit" variant="contained">
            {t("controlPanelUpdateFormButtonSecond")}
          </MuiButton>
        </ButtonContainer>
      </form>
    </>
  );
};

export default Form;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;
  font-size: 14px;
`;

const KeyTitle = styled.p`
  font-size: 16px;
`;

const KeyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 30px;
  .key_copy {
    display: flex;
    align-items: center;
    gap: 20px;
  }
`;

const ShowKey = styled.div`
  .top {
    display: flex;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    h1 {
      font-size: 20px;
      color: #0c7fd6;
    }
    img {
      height: 25px;
    }
    .arrow-down {
      transform: rotate(0deg);
      transition: transform 0.3s linear;
    }
    .arrow-down.open {
      transform: rotate(180deg);
      transition: transform 0.3s linear;
    }
  }
`;
